import filterFactory from '@/mixins/filterFactory/filterFactory';

var Filter = (function () {
    function Filter() {
        this.filter = {};
        this.filterConfigs = {};
    };
    Filter.prototype.setterFilterConfigs = function (data={}) {
        let configKeys = Object.keys(data);
        configKeys.forEach(key => {
            let config = data[key];
            if(config.hasOwnProperty('type') && config.hasOwnProperty('classname')) {
                this.filterConfigs[key] = config;
            }
        })
    };
    Filter.prototype.getterFilterCongifs = function() {
        return this.filterConfigs;
    };
    Filter.prototype.filterValidator = function (key=null, type=null, classname=null) {
        if(!key || !type || !classname) {
            return false;
        }
        return true;
    };
    Filter.prototype.isEmptyValue = function(value=null, classname=null) {
        if((value === null || value === '')) {
            return true;
        }else if(Array.isArray(value) && value.length === 2 && (value[0] === '' || value[0] === null) && (value[1] === '' || value[1] === null)){
            return true;
        }
        return false;
    };
    Filter.prototype.deleteFilterObj = function(classname) {
        delete this.filter[classname];
    };
    Filter.prototype.setterFilter = function(key=null, value=null) {
        let classname = this.filterConfigs[key].classname;
        let type = this.filterConfigs[key].type;
        if(!this.filterValidator(key, type, classname)) {
            return;
        }
        if(this.isEmptyValue(value, classname)) {
            this.deleteFilterObj(classname);
        }else{
            let filterfactory = filterFactory.filterCreate(type);
            filterfactory.setterFilter(key, value, classname)
            let obj = filterfactory.getterFilter();
            this.filter[classname] = obj;
        }
        return this.filter;
    };
    Filter.prototype.initFilter = function (parserData) {
        let filterKeys = Object.keys(parserData);
        filterKeys.forEach(filterKey => {
            let key = filterKey;
            let value = parserData[filterKey];
            let type = this.filterConfigs[filterKey].type;
            if(type == 'between') {
                let filterfactory = filterFactory.filterCreate(type);
                value = filterfactory.parserReturnValue(value);
            }
            this.setterFilter(key, value);
        });
        return this.filter;
    }
    return Filter;
})();

export default Filter;